import { DESKTOP_SPACING } from "@/theme";
import { StyledButton } from "../Button";
import { StyledButtonsGroup } from "../ButtonsGroup";
import { StyledHeading } from "../Typography/Heading";
import { StyledPageHeaderProps } from "./PageHeader.interface";
import { StyledTypo } from "../Typography/Typo";
import styled from "styled-components";

export const StyledPageHeader = styled.div<StyledPageHeaderProps>`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${DESKTOP_SPACING.XXL}px;
  ${({ isResponsive }) => isResponsive ?  '@media (max-width: 660px) { position: absolute; z-index:999; right:0; }' : '' }
  
  ${StyledHeading} {
    order: 1;
    flex: 1;
  }

  ${StyledButton} {
    order: 2;
    width: auto;
  }

  ${StyledButtonsGroup} {
    order: 2;
    width: auto;
  }

  ${StyledTypo} {
    order: 3;
    width: 100%;
  }
`;
